import { GetterTree } from 'vuex'
import { TransportsState } from './types';
import { MsgTransports, RootState } from '../types';

export const getters: GetterTree<TransportsState, RootState> = {
    transports:state => state.transports ?? [],
    transportsForOriginatorsList:state => state.transports.filter((value: any) => ![MsgTransports.PUSH, MsgTransports.MAILNOTIFY].includes(value)) ?? [],
    transportsMultichannel:state => state.transportsMultichannel ?? [],
};